const stubUrls = [
  "cayo.graph.typeAnnotation",
  "cayo.graph.networkSettings",
  "system/alerts",
  "effectiveAnnotations",
  "getProductConfigSummary",
];

export const getStubResponse = (
  input: RequestInfo | URL,
  clientId?: string
): Response | undefined => {
  if (clientId !== "cayo.admin.web") {
    return undefined;
  }
  const url = typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
  if (stubUrls.some((s) => url.includes(s))) {
    return new Response(JSON.stringify([]), {
      status: 200,
      headers: { "Content-Type": "application/json" },
    });
  }
  return undefined;
};
